module.exports = __webpack_public_path__ + "static/Structure3DLoads-ec5144be1ff72b1dcd769870379eaf0f.jpg";